var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"black","elevation":"0","dark":"","small":"","loading":_vm.isLoading},on:{"click":_vm.onDownload}},[_vm._v(" Download "),_c('v-icon',{attrs:{"right":""}},[_vm._v(_vm._s("mdi-download"))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }